import {
  Checkbox,
  KoAvatar,
  KoBadge,
  KoButton,
  KoDropdown,
  KoModal,
  KoRow,
  KoSearch,
  KoText,
  KoTitle,
  KoToast,
  KoTooltips,
  KoLoader,
  Upload
} from "packages";
import KoIcon from '@kwapio/icons';
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router";
import { PRIORITY } from "shared/commonConstants";
import styles from "./toolbar.module.scss";
import { getCookie, setCookie } from "shared/utils/cookies";
import { getCurrentAssignees } from "shared/store/currentAssigneesSlice";
import { useDispatch } from "react-redux";
import csvTemplate from './sample.csv';
import { DevelopmentAPI } from "pages/workspace/process/development/development.service";

function KoToolBar(props) {
  const dispatch = useDispatch();
  const currentAssignees = useSelector(state => state?.currentAssignees);
  const [assignees, setAssignees] = useState(currentAssignees['data'] || []);
  const [errors, setErrors] = useState();
  const {workspaceId} = useParams();
  const [workspace, setWorkspace] = useState();
  const [components, setComponents] = useState([]);
  const [modules, setModules] = useState([]);



  useEffect(() => {
    if (workspaceId) {
      dispatch(getCurrentAssignees(workspaceId));
      getWorkspace(workspaceId);
      getComponents(workspaceId);
      getModules(workspaceId);
    }
  }, [workspaceId]);

  useEffect(() => {
    setAssignees(currentAssignees['data']);
  }, [currentAssignees]);

  const {
    title,
    buttonList = [],
    search,
    className,
    onChangeStatus,
    onChangeType,
    onChangePriority,
    onChangeAssignees,
    onChangeReporter,
    onChangeComponent,
    onChangeModule,
    isExport,
    isImport,
    filterOptions,
    handleExport,
    isEpic,
    Bulk:{
      visible : bulkVisible,
      selectedTickets = 0,
      setBulkModal
    }
  } = props;
  const [open, setOpen] = useState(false);
  const [openPriority, setOpenPriority] = useState(false);
  const [openStatus, setOpenStatus] = useState(false);
  const [issueKeys, setIssueKeys] = useState([]);
  const [priorityKeys, setPriorityKeys] = useState([]);
  const [statusKeys, setStatusKeys] = useState([]);
  const [openAssignees, setOpenAssignees] = useState(false);
  const [selectedAssignees, setSelectedAssignees] = useState([]);
  const [openReporter, setOpenReporter] = useState(false);
  const [openComponent, setOpenComponent] = useState(false);
  const [openModule, setOpenModule] = useState(false);
  const [reporterKeys, setReporterKeys] = useState([]);
  const [componentKeys, setComponentKeys] = useState([]);
  const [moduleKeys, setModuleKeys] = useState([]);
  const [openImport, setOpenImport] = useState(false);
  const [fileList, setFileList] = useState([]);
  const [loading, setLoader] = useState(false);
  const [componentSearch, setComponentSearch] = useState("");
  const [moduleSearch, setModuleSearch] = useState("");
  const [reporterSearch, setReporterSearch] = useState("");
  const [assigneeSearch, setAssigneeSearch] = useState("");
  const handleMenuClickIssue = (key, isChecked) => {
    let updatedStatusKeys;
    if (isChecked) {
      updatedStatusKeys = [...issueKeys, key];
    } else {
      updatedStatusKeys = issueKeys.filter((id) => id !== key);
    }
    setIssueKeys(updatedStatusKeys);
    onChangeType && onChangeType(updatedStatusKeys);
  };

  const getWorkspace = (id) => {
    if(!id) return;
    DevelopmentAPI.getWorkspaceById(id).then(
      (res) => {
        setWorkspace(res?.project);
      }
    );
  };

  const getComponents = (id) => {
    if(!id) return;
    DevelopmentAPI.getComponents({}, id).then(
      (res) => {
        setComponents(res?.components || []);
      }
    );
  };

  const getModules = (id) => {
    if(!id) return;
    DevelopmentAPI.getModules({}, id).then(
      (res) => {
        setModules(res?.modules || []);
      }
    );
  };

  const handleMenuClickPriority =  (key, isChecked) => {
    let updatedStatusKeys;
    if (isChecked) {
      updatedStatusKeys = [...priorityKeys, key];
    } else {
      updatedStatusKeys = priorityKeys.filter((id) => id !== key);
    }
    setPriorityKeys(updatedStatusKeys);
    onChangePriority(updatedStatusKeys);
  };

  const handleMenuClickStatus =  (key, isChecked) => {

    let updatedStatusKeys;
    if (isChecked) {
      updatedStatusKeys = [...statusKeys, key];
    } else {
      updatedStatusKeys = statusKeys.filter((id) => id !== key);
    }
    setStatusKeys(updatedStatusKeys);
    onChangeStatus(updatedStatusKeys);
  };

  const handleReporterChange = (key, checked) => {
    let updated = checked
      ? [...reporterKeys, key]
      : reporterKeys.filter(id => id !== key);

    setReporterKeys(updated);
    onChangeReporter && onChangeReporter(updated);
  };

  const handleComponentChange = (key, checked) => {
    let updated = checked
      ? [...componentKeys, key]
      : componentKeys.filter(id => id !== key);

    setComponentKeys(updated);
    onChangeComponent && onChangeComponent(updated);
  };

  const handleModuleChange = (key, checked) => {
    let updated = checked
      ? [...moduleKeys, key]
      : moduleKeys.filter(id => id !== key);

    setModuleKeys(updated);
    onChangeModule && onChangeModule(updated);
  };

  const handleOpenChange = (nextOpen, info) => {
    if (info.source === "trigger" || nextOpen) {
      setOpen(nextOpen);
    }
  };

  const handleOpenChangePriority = (nextOpen, info) => {
    if (info.source === "trigger" || nextOpen) {
      setOpenPriority(nextOpen);
    }
  };
  const handleOpenChangeReporter = (nextOpen, info) => {
    if (info.source === "trigger" || nextOpen) {
      setOpenReporter(nextOpen);
    }
  };

  const handleOpenChangeStatus = (nextOpen, info) => {
    if (info.source === "trigger" || nextOpen) {
      setOpenStatus(nextOpen);
    }
  };

  const handleClearAllFilters = () => {
    setIssueKeys([]);
    setPriorityKeys([]);
    setStatusKeys([]);
    setSelectedAssignees([]);
    setReporterKeys([]);
    setComponentKeys([]);
    setModuleKeys([]);
    onChangeType &&  onChangeType([]);
    onChangePriority && onChangePriority([]);
    onChangeStatus && onChangeStatus([]);
    onChangeAssignees && onChangeAssignees([]);
    onChangeReporter && onChangeReporter([]);
    onChangeComponent && onChangeComponent([]);
    onChangeModule && onChangeModule([]);

  };

  const handleOpenChangeAssignees = (nextOpen, info) => {
    if (info.source === 'trigger' || nextOpen) {
      setOpenAssignees(nextOpen);
    }
  };
  const activityTypes = workspace?.template?.activityTypes || filterOptions?.activityType;
  const workflow = workspace?.template?.workflow || filterOptions?.workflow;
  
  const issueTypesList = activityTypes?.map((issue) => ({
    label: (
      <div className={`${styles.filterList} ${issueKeys.includes(issue.value) ? styles.selected : ""}`}>
        <Checkbox
          checked={issueKeys.includes(issue.value)}
          onChange={(e) => handleMenuClickIssue(issue.value, e.target.checked)}>
          <div className={styles.userDpWithName}>
            <KoIcon name={issue.icon} />
            <KoText text={issue.label} />
          </div>
        </Checkbox>
      </div>
    ),
    key: issue?.key,
    value: issue?.key
  }));
  
  const filteredAssignees = (assignees || []).filter((user) =>
  `${user.profile?.firstName} ${user.profile?.lastName}`
    .toLowerCase()
    .includes(assigneeSearch.toLowerCase())
  );

  const assigneesItems = filteredAssignees.map((user) => ({
    label: (
      <div className={`${styles.filterList} ${selectedAssignees.includes(user.userId) ? styles.selected : ""}`}>
        <Checkbox
          checked={selectedAssignees.includes(user.userId)}
          onChange={(e) => handleUserSelection(user.userId, e.target.checked)}
        >
          <div className={styles.userDpWithName}>
            <KoAvatar
              inLine={'0rem'}
              size={20}
              options={[{ name: user?.profile?.firstName, logo: user?.profile?.logo }]}
            />
            <KoText text={`${user.profile?.firstName} ${user.profile?.lastName}`} />
          </div>
        </Checkbox>
      </div>
    ),
    key: user?.userId
  }));

  
  const filteredReporters = (assignees || []).filter((user) =>
  `${user.profile?.firstName} ${user.profile?.lastName}`
    .toLowerCase()
    .includes(reporterSearch.toLowerCase())
  );

  const reporterItems = filteredReporters.map((user) => ({
    label: (
      <div
        className={`${styles.filterList} ${
        reporterKeys.includes(user.userId) ? styles.selected : ""
      }`}
      >
        <Checkbox
          checked={reporterKeys.includes(user.userId)}
          onChange={(e) =>
            handleReporterChange(user.userId, e.target.checked)
          }
        >
          <div className={styles.userDpWithName}>
            <KoAvatar
              inLine={"0rem"}
              size={20}
              options={[
                {
                  name: user?.profile?.firstName,
                  logo: user?.profile?.logo
                }
              ]}
            />
            <KoText
              text={`${user.profile?.firstName} ${user.profile?.lastName}`}
            />
          </div>
        </Checkbox>
      </div>
    ),
    key: user?.userId,
    value: user?.userId
  }));

  const statusItems =workflow?.map((sta) => ({
    label: (
      <div className={`${styles.filterList} ${statusKeys.includes(sta.value) ? styles.selected : ""}`}>
        <Checkbox
          checked={statusKeys.includes(sta.value)}
          onChange={(e) => handleMenuClickStatus(sta.value, e.target.checked)}>
          <div className={styles.userDpWithName}>
            <div className="statusCircle" style={{ borderColor: sta.color }} />
            <KoText text={sta.label} />
          </div>
        </Checkbox>
      </div>
    ),
    key: sta?.key,
    value: sta?.value
  }));
  const priorityItems = PRIORITY?.map((prty) => ({
    label: (
      <div className={`${styles.filterList} ${priorityKeys.includes(prty.key) ? styles.selected : ""}`}>
        <Checkbox
          checked={priorityKeys.includes(prty.key)}
          onChange={(e) => handleMenuClickPriority(prty.key, e.target.checked)}
        >
          <div className={styles.userDpWithName}>
            {prty?.label}
          </div>
        </Checkbox>
      </div>
    ),
    key: prty?.key,
    value: prty?.value
  }));

  const filteredComponents = (components || []).filter((comp) =>
    comp.name?.toLowerCase().includes(componentSearch.toLowerCase())
  );

  const componentItems = filteredComponents.map((comp) => ({
    label: (
      <div className={`${styles.filterList} ${componentKeys.includes(comp.componentId) ? styles.selected : ""}`}>
        <Checkbox
          checked={componentKeys.includes(comp.componentId)}
          onChange={(e) => handleComponentChange(comp.componentId, e.target.checked)}
        >
          <KoText text={comp.name} />
        </Checkbox>
      </div>
    ),
    key: comp.componentId
    
  }));

  const filteredModules = (modules || []).filter((mod) =>
    mod.name?.toLowerCase().includes(moduleSearch.toLowerCase())
  );

  const moduleItems = filteredModules.map((mod) => ({
    label: (
      <div className={`${styles.filterList} ${moduleKeys.includes(mod.moduleId) ? styles.selected : ""}`}>
        <Checkbox
          checked={moduleKeys.includes(mod.moduleId)}
          onChange={(e) => handleModuleChange(mod.moduleId, e.target.checked)}
        >
          <KoText text={mod.name} />
        </Checkbox>
      </div>
    ),
    key: mod.moduleId
  }));
  

  const handleUserSelection = (userId, isChecked) => {
    let updatedSelectedUsers;
    if (isChecked) {
      updatedSelectedUsers = [...selectedAssignees, userId];
    } else {
      updatedSelectedUsers = selectedAssignees.filter((id) => id !== userId);
    }
    setSelectedAssignees(updatedSelectedUsers);
    onChangeAssignees(updatedSelectedUsers);
  };

  const handleUpload = () => {
    if (!fileList.length) {
      KoToast.error("Please select a file to upload.");
      return;
    }

    const formData = new FormData();
    fileList.forEach((file) => {
      formData.append("file", file);
    });

    setLoader(true);

    fetch(
      `${process.env.REACT_APP_PROXY_HOST}/api/v1/taskplanner/ticket/import`,
      {
        method: "POST",
        body: formData,
        headers: {
          Authorization: `Bearer ${getCookie("accessToken")}`,
          workspace: String(workspaceId)
        }
      }
    )
      .then(async(res) => {
        const data = await res.json();

        if (!res.ok) {
          setErrors(data);
          throw new Error(data?.message || "Upload failed.");
        }

        
        if (data?.jobId) {
          setCookie("jobId", data.jobId);
        }

        return data;
      })
      .then(() => {
        KoToast.success(
          "Tickets imported successfully. Non-sprint tickets moved to backlog."
        );
        setErrors();
        setOpenImport(false);
        setFileList([]);
      })
      .catch((error) => {
        console.error("Upload error:", error);
        KoToast.error(error.message || "Upload failed.");
      })
      .finally(() => {
        setLoader(false);
      });
  };



  const handleDownloadTemplate = () => {
    const link = document.createElement("a");
    link.href = csvTemplate;
    link.setAttribute("download", "ticket_template.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const uploadProps = {
    onRemove: (file) => {
      const index = fileList.indexOf(file);
      const newFileList = fileList.slice();
      newFileList.splice(index, 1);
      setFileList(newFileList);
    },
    beforeUpload: (file) => {
      setFileList([file]);
      return false;
    },
    fileList
  };

  return (
    <>
      <KoRow className={`${styles.wrapper} ${className ? className : ""}`}>
        {title ? <KoTitle level={5} text={title} /> : <div>&nbsp;</div>}
        <div className={styles.rightContent}>
          {search?.visible && (
            <KoSearch
              allowClear={true}
              onChange={(e) => search?.onChange(e.target.value)}
              placeholder={search?.placeholder}
            />
          )}
          {isImport&& <KoTooltips title="Import issues from CSV">
            <KoButton
              iconBtn={true}
              onClick={setOpenImport}
              icon={<KoIcon name="ImportOutlined" />}
            />
          </KoTooltips>}

          {isEpic&& <KoTooltips title="Create Epic">
            <KoButton
              label="Create Epic"
              onClick={isEpic}
              type="primary"
            />
          </KoTooltips>}

          {isExport&& <KoTooltips title="Export issues to CSV">
            <KoButton
              iconBtn={true}
              onClick={handleExport}
              icon={<KoIcon name="ExportOutlined" />}
            />
          </KoTooltips>}
          {onChangeType &&  <KoDropdown
            onOpenChange={handleOpenChange}
            open={open}
            placement="bottomRight"
            menu={{items: issueTypesList }}>
            <div>
              <KoBadge  count={issueKeys?.length}>
                <KoTooltips title="Filter by issue type">
                  <KoButton
                    iconBtn={true}
                    icon={<KoIcon name="ProjectsOutlined" />}
                  />
                </KoTooltips>
              </KoBadge>
            </div>
          </KoDropdown>}

          {onChangePriority &&  <KoDropdown
            onOpenChange={handleOpenChangePriority}
            open={openPriority}
            placement="bottomRight"
            menu={{items: priorityItems}}>
            <div>
              <KoBadge  count={priorityKeys?.length}>
                <KoTooltips title="Filter by priority">
                  <KoButton
                    iconBtn={true}
                    icon={<KoIcon name="PriorityFilled" />}
                  />
                </KoTooltips>
              </KoBadge>
            </div>
          </KoDropdown>}

          {onChangeStatus && <KoDropdown
            onOpenChange={handleOpenChangeStatus}
            open={openStatus}
            placement="bottomRight"
            menu={{items: statusItems}}>
            <div>
              <KoBadge  count={statusKeys?.length}>
                <KoTooltips title="Filter by status">
                  <KoButton iconBtn={true} icon={<KoIcon name="StatusFilled" />} />
                </KoTooltips>
              </KoBadge>
            </div>
          </KoDropdown>}

          {onChangeAssignees && <KoDropdown
            onOpenChange={handleOpenChangeAssignees}
            open={openAssignees}
            placement="bottomRight"
            menu={{ items: assigneesItems }}
            dropdownRender={(menu) => (
              <div className={styles.dropdownContainer}>
                <div className={styles.dropdownSearch}>
                  <KoSearch
                    placeholder="Search assignee..."
                    allowClear
                    onChange={(e) => setAssigneeSearch(e.target.value)}
                  />
                </div>
                <div className={styles.dropdownMenu}>
                  {menu}
                </div>
              </div>
            )}>
            <div>
              <KoBadge  count={selectedAssignees?.length}>
                <KoTooltips title='Filter by assignees'>
                  <KoButton iconBtn={true} icon={<KoIcon name='UsersOutlined'/>}/>
                </KoTooltips>
              </KoBadge>
            </div>
          </KoDropdown>}
          {/* Reporter Filter */}
          {onChangeReporter && (
            <KoDropdown
              onOpenChange={handleOpenChangeReporter}
              open={openReporter}
              placement="bottomRight"
              menu={{ items: reporterItems }}
              dropdownRender={(menu) => (
                <div className={styles.dropdownContainer}>
                  <div className={styles.dropdownSearch}>
                    <KoSearch
                      placeholder="Search reporter..."
                      allowClear
                      onChange={(e) => setReporterSearch(e.target.value)}
                    />
                  </div>
                  <div className={styles.dropdownMenu}>
                    {menu}
                  </div>
                </div>
              )}
            >
              <div>
                <KoBadge count={reporterKeys.length}>
                  <KoTooltips title="Filter by reporter">
                    <KoButton iconBtn icon={<KoIcon name="UsersOutlined" />} />
                  </KoTooltips>
                </KoBadge>
              </div>
            </KoDropdown>
          )}

          {/* Component Filter */}
          {onChangeComponent && (
            <KoDropdown
              onOpenChange={(nextOpen, info) => {
                if (info.source === 'trigger' || nextOpen) {
                  setOpenComponent(nextOpen);
                }
              }}
              open={openComponent}
              placement="bottomRight"
              menu={{ items: componentItems }}
              dropdownRender={(menu) => (
                <div className={styles.dropdownContainer}>
                  <div className={styles.dropdownSearch}>
                    <KoSearch
                      placeholder="Search component..."
                      allowClear
                      onChange={(e) => setComponentSearch(e.target.value)}
                    />
                  </div>
                  <div className={styles.dropdownMenu}>
                    {menu}
                  </div>
                </div>
              )}
            >
              <div>
                <KoBadge count={componentKeys.length}>
                  <KoTooltips title="Filter by component">
                    
                    <KoButton iconBtn={true} icon={<KoIcon name='ComponentsOutlined' />} />
                  </KoTooltips>
                </KoBadge>
              </div>
            </KoDropdown>
          )}

         
          {onChangeModule && (
            <KoDropdown
              onOpenChange={(nextOpen, info) => {
                if (info.source === 'trigger' || nextOpen) {
                  setOpenModule(nextOpen);
                }
              }}
              open={openModule}
              placement="bottomRight"
              menu={{ items: moduleItems }}
              dropdownRender={(menu) => (
                <div className={styles.dropdownContainer}>
                  <div className={styles.dropdownSearch}>
                    <KoSearch
                      placeholder="Search module..."
                      allowClear
                      onChange={(e) => setModuleSearch(e.target.value)}
                    />
                  </div>
                  <div className={styles.dropdownMenu}>
                    {menu}
                  </div>
                </div>
              )}
            >
              <div>
                <KoBadge count={moduleKeys.length}>
                  <KoTooltips title="Filter by module">
                    <KoButton iconBtn={true} icon={<KoIcon name="ModulesOutlined" />} />
                  </KoTooltips>
                </KoBadge>
              </div>
            </KoDropdown>
          )}

          <div>
            <KoTooltips title="Reset Filter">
              <KoButton
                type="default"
                iconBtn={true}
                icon={<KoIcon name="ResetOutlined" />}
                onClick={handleClearAllFilters}
                className={styles.clearAllBtn}
              />
            </KoTooltips>
          </div>
          {
            bulkVisible &&
        <KoButton icon={<KoIcon color="#FFF" name="EditOutlined" width={18} height={18}/>} onClick={()=>setBulkModal(true)} disabled={!selectedTickets || selectedTickets.length === 0}
          className={`${styles.btn} ${selectedTickets?.length ===0 ? styles.disbaled :''}`} label='Bulk Change'/>
          }

          {buttonList?.map((btn) => (
            <div key={btn.label} className={styles.actionList}>
              <KoButton {...btn}className={props?.btnDangerCls}/>
            </div>
          ))}
        </div>
      
      </KoRow>
      <KoModal
        title={`Import issues from CSV`}
        centered
        open={openImport}
        handleOk={() => {setOpenImport(false); setErrors(); setFileList([]);}}
        onClose={() => {setOpenImport(false); setErrors(); setFileList([]);}}
        
        footer={[
          <KoButton key='cancel' label='Cancel' onClick={() => {setOpenImport(false); setErrors(); setFileList([]);}} />,
          <KoButton key='upload' onClick={() => handleUpload()}  type='primary' label={ `Import`}/>
        ]}
      >
        

        <div className={styles.modalContent}>
          {loading && <KoLoader/>}
          <KoText text="Download CSV Template" className={styles.templateText} onClick={handleDownloadTemplate} />
          <Upload {...uploadProps} accept=".csv" className={styles.uploadWrapper}>
            <div className={styles.upload}>
              <KoIcon width={24} height={24} name="ImportOutlined" />
              {fileList.length === 0 && <div className={styles.upload}>
                <KoText text="Click to upload the CSV file" />
              </div>}
            </div>
          </Upload>

          {
            errors &&
            <div className={styles.errorWrapper}>
              <KoTitle level={5} text="Upload information" />
              <div className={styles.errorRow}>
                <KoText text={`Created Tickets: ${errors?.createdTickets}`} className={styles.success} />
                <KoText text={`Failed Tickets: ${errors?.failedTickets}`} className={styles.error} />
                <KoText text={`Total Tickets: ${errors?.totalTickets}`} className={styles.total} />
              </div>
              <ul>
                {
                  errors?.errors?.map((error, index) => (
                    <li key={index}>
                      <KoText text={error} className={styles.errorText} />
                    </li>
                  ))
                }
              </ul>
            </div>
          }
        </div>
        
      </KoModal>

    </>
  );
}
export default KoToolBar;
